import { TextField } from '@mui/material'
import type { TextFieldProps } from '@mui/material'

type InputProps = {
  type?: string
} & TextFieldProps

const InputField: React.FC<InputProps> = (props) => {
  return (
    <TextField {...props}
      InputProps={{
        style: {
          color: '#7D8FB3',
          borderRadius: '30px',
          paddingLeft: 15,
          paddingRight: 15,
          fontSize: 14,
          fontWeight: 700,
          letterSpacing: 0.01
        }
      }}
      InputLabelProps={{
        style: { color: '#ADB8CC' }
      }}
    />
  )
}

export default InputField
